import { ButtonLink } from 'components/Button/ButtonLink';
import { useLocale } from 'containers/App/LocaleContext';
import { PickConfig } from 'pages/Management/Configuration/PickConfig';
import { memo, useState } from 'react';
import type { FC } from 'react';
import { Helmet } from 'react-helmet';
import { ConfigurationDiffModal } from './ConfigurationDiffModal';
import type { CompareManagementConfigurationConfig } from './types';

const BareConfigurationPage: FC = () => {
  const cfgMsg = useLocale().managementConfiguration;
  const [currentDiff, setCurrentDiff] = useState<
    | [
        CompareManagementConfigurationConfig,
        CompareManagementConfigurationConfig,
      ]
    | undefined
  >(undefined);

  return (
    <div className='flex flex-col flex-1 gap p'>
      <Helmet title={cfgMsg.title} />
      <div>
        {/* reset flex */}
        <ButtonLink
          variant='secondary'
          type='button'
          to='/management/configuration/connectivity-errors'
        >
          {cfgMsg.btnConnectivityErrors}
        </ButtonLink>
      </div>
      <PickConfig
        onCompare={(
          configs: [
            CompareManagementConfigurationConfig,
            CompareManagementConfigurationConfig,
          ],
        ) => {
          setCurrentDiff(configs);
        }}
      />
      {currentDiff && (
        <ConfigurationDiffModal
          leftConfig={currentDiff[0]}
          rightConfig={currentDiff[1]}
          onClose={() => {
            setCurrentDiff(undefined);
          }}
        />
      )}
    </div>
  );
};

export const ConfigurationPage = memo(BareConfigurationPage);
